import { render, staticRenderFns } from "./CollectorOrderDetail.vue?vue&type=template&id=03aba174&scoped=true&"
import script from "./CollectorOrderDetail.vue?vue&type=script&lang=js&"
export * from "./CollectorOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aba174",
  null
  
)

export default component.exports